const countries = [
  {
    id: '1',
    label: '中国内地',
    value: '中国内地',
    children: [
      { id: '101', label: '北京', value: '北京' },
      { id: '102', label: '上海', value: '上海' },
      { id: '103', label: '杭州', value: '杭州' },
      { id: '104', label: '南京', value: '南京' },
      { id: '105', label: '西安', value: '西安' },
      { id: '106', label: '成都', value: '成都' },
      { id: '107', label: '重庆', value: '重庆' },
      { id: '108', label: '武汉', value: '武汉' }
    ]
  },
  {
    id: '2',
    label: '粤港澳大湾区',
    value: '粤港澳大湾区',
    children: [
      { id: '201', label: '香港', value: '香港' },
      { id: '202', label: '澳门', value: '澳门' },
      { id: '203', label: '深圳', value: '深圳' },
      { id: '204', label: '广州', value: '广州' },
      { id: '205', label: '珠海', value: '珠海' },
      { id: '206', label: '佛山', value: '佛山' },
      { id: '207', label: '中山', value: '中山' },
      { id: '208', label: '惠州', value: '惠州' },
      { id: '209', label: '东莞', value: '东莞' },
      { id: '210', label: '江门', value: '江门' },
      { id: '211', label: '肇庆', value: '肇庆' }
    ]
  },
  {
    id: '3',
    label: '中国台湾',
    value: '中国台湾'
  },
  {
    id: '4',
    label: '亚洲',
    value: '亚洲',
    children: [
      { id: '401', label: '韩国', value: '韩国' },
      { id: '402', label: '日本', value: '日本' },
      { id: '403', label: '东盟', value: '东盟', children: [
        { id: '40301', label: '新加坡', value: '新加坡' },
        { id: '40302', label: '越南', value: '越南' },
        { id: '40303', label: '马来西亚', value: '马来西亚' },
        { id: '40304', label: '泰国', value: '泰国' },
        { id: '40305', label: '文莱', value: '文莱' },
        { id: '40306', label: '印度尼西亚', value: '印度尼西亚' },
        { id: '40307', label: '菲律宾', value: '菲律宾' },
        { id: '40308', label: '老挝', value: '老挝' },
        { id: '40309', label: '缅甸', value: '缅甸' },
        { id: '40310', label: '柬埔寨', value: '柬埔寨' }
      ]},
      { id: '404', label: '中东', value: '中东', children: [
        { id: '40401', label: '以色列', value: '以色列' },
        { id: '40402', label: '沙特阿拉伯', value: '沙特阿拉伯' },
        { id: '40403', label: '伊朗', value: '伊朗' },
        { id: '40404', label: '阿拉伯联合酋长国', value: '阿拉伯联合酋长国' },
        { id: '40405', label: '卡塔尔', value: '卡塔尔' },
        { id: '40406', label: '伊拉克', value: '伊拉克' },
        { id: '40407', label: '科威特', value: '科威特' },
        { id: '40408', label: '叙利亚', value: '叙利亚' },
        { id: '40409', label: '阿曼', value: '阿曼' },
        { id: '40410', label: '巴林', value: '巴林' }
      ]},
      { id: '405', label: '中亚', value: '中亚', children: [
        { id: '40501', label: '哈萨克斯坦', value: '哈萨克斯坦' },
        { id: '40502', label: '吉尔吉斯斯坦', value: '吉尔吉斯斯坦' },
        { id: '40503', label: '土库曼斯坦', value: '土库曼斯坦' },
        { id: '40504', label: '乌兹别克斯坦', value: '乌兹别克斯坦' },
        { id: '40505', label: '塔吉克斯坦', value: '塔吉克斯坦' }
      ]},
      { id: '406', label: '南亚', value: '南亚', children: [
        { id: '40601', label: '巴基斯坦', value: '巴基斯坦' },
        { id: '40602', label: '印度', value: '印度' },
        { id: '40603', label: '孟加拉国', value: '孟加拉国' },
        { id: '40604', label: '尼泊尔', value: '尼泊尔' },
        { id: '40605', label: '不丹', value: '不丹' },
        { id: '40606', label: '斯里兰卡', value: '斯里兰卡' },
        { id: '40607', label: '马尔代夫', value: '马尔代夫' }
      ]}
    ]
  },
  {
    id: '5',
    label: '欧洲',
    value: '欧洲',
    children: [
      { id: '501', label: '欧盟', value: '欧盟', children: [
        { id: '50101', label: '法国', value: '法国' },
        { id: '50102', label: '德国', value: '德国' },
        { id: '50103', label: '意大利', value: '意大利' },
        { id: '50104', label: '荷兰', value: '荷兰' },
        { id: '50105', label: '西班牙', value: '西班牙' },
        { id: '50106', label: '葡萄牙', value: '葡萄牙' },
        { id: '50107', label: '波兰', value: '波兰' },
        { id: '50108', label: '希腊', value: '希腊' },
        { id: '50109', label: '保加利亚', value: '保加利亚' },
        { id: '50110', label: '奥地利', value: '奥地利' },
        { id: '50111', label: '比利时', value: '比利时' },
        { id: '50112', label: '瑞典', value: '瑞典' },
        { id: '50113', label: '匈牙利', value: '匈牙利' },
        { id: '50114', label: '塞浦路斯', value: '塞浦路斯' },
        { id: '50115', label: '芬兰', value: '芬兰' }
      ]},
      { id: '502', label: '英国', value: '英国' },
      { id: '503', label: '俄罗斯', value: '俄罗斯' },
      { id: '504', label: '土耳其', value: '土耳其' },
      { id: '505', label: '瑞士', value: '瑞士' },
      { id: '506', label: '挪威', value: '挪威' },
      { id: '507', label: '乌克兰', value: '乌克兰' }
    ]
  },
  {
    id: '6',
    label: '北美洲',
    value: '北美洲',
    children: [
      { id: '601', label: '美国', value: '美国' },
      { id: '602', label: '加拿大', value: '加拿大' },
      { id: '603', label: '墨西哥', value: '墨西哥' }
    ]
  },
  {
    id: '7',
    label: '南美洲',
    value: '南美洲',
    children: [
      { id: '701', label: '巴西', value: '巴西' },
      { id: '702', label: '委内瑞拉', value: '委内瑞拉' },
      { id: '703', label: '秘鲁', value: '秘鲁' },
      { id: '704', label: '智利', value: '智利' },
      { id: '705', label: '哥伦比亚', value: '哥伦比亚' },
      { id: '706', label: '玻利维亚', value: '玻利维亚' },
      { id: '707', label: '巴拉圭', value: '巴拉圭' },
      { id: '708', label: '乌拉圭', value: '乌拉圭' },
      { id: '709', label: '厄瓜多尔', value: '厄瓜多尔' }
    ]
  },
  {
    id: '8',
    label: '大洋洲',
    value: '大洋洲',
    children: [
      { id: '801', label: '澳大利亚', value: '澳大利亚' },
      { id: '802', label: '新西兰', value: '新西兰' },
      { id: '803', label: '巴布亚新几内亚', value: '巴布亚新几内亚' }
    ]
  },
  {
    id: '9',
    label: '非洲',
    value: '非洲',
    children: [
      { id: '901', label: '南非', value: '南非' },
      { id: '902', label: '尼日利亚', value: '尼日利亚' },
      { id: '903', label: '毛里求斯', value: '毛里求斯' },
      { id: '904', label: '肯尼亚', value: '肯尼亚' },
      { id: '905', label: '埃及', value: '埃及' },
      { id: '906', label: '阿尔及利亚', value: '阿尔及利亚' },
      { id: '907', label: '摩洛哥', value: '摩洛哥' },
      { id: '908', label: '突尼斯', value: '突尼斯' },
      { id: '909', label: '坦桑尼亚', value: '坦桑尼亚' },
      { id: '910', label: '几内亚', value: '几内亚' },
      { id: '911', label: '埃塞俄比亚', value: '埃塞俄比亚' },
      { id: '912', label: '赞比亚', value: '赞比亚' }
    ]
  }
]
const languages = [
  { id: '101', label: '中文', value: '中文' },
  { id: '102', label: '英文', value: '英文' },
  { id: '103', label: '阿拉伯语', value: '阿拉伯语' },
  { id: '104', label: '俄语', value: '俄语' },
  { id: '105', label: '西班牙语', value: '西班牙语' },
  { id: '106', label: '葡萄牙语', value: '葡萄牙语' },
  { id: '107', label: '法语', value: '法语' }
]
const professions = [
  { id: '101', label: '新能源', value: '新能源' },
  { id: '102', label: '生物医药', value: '生物医药' },
  { id: '103', label: '新一代信息技术', value: '新一代信息技术' },
  { id: '104', label: '新材料产业集群', value: '新材料产业集群' },
  { id: '105', label: '人工智能', value: '人工智能' },
  { id: '106', label: '智能机器人', value: '智能机器人' },
  { id: '107', label: '高端制造', value: '高端制造' },
  { id: '108', label: '安全节能环保', value: '安全节能环保' },
  { id: '108', label: '大健康', value: '大健康' },
  { id: '108', label: '海洋产业集群', value: '海洋产业集群' }
]
const segments = [
  {
    id: '1',
    label: '公司业务类',
    value: '公司业务类',
    children: [
      { id: '101', label: '跨境投资', value: '跨境投资' },
      { id: '102', label: '跨境金融', value: '跨境金融' },
      { id: '103', label: '海外并购', value: '海外并购' },
      { id: '104', label: '海外上市', value: '海外上市' },
      { id: '105', label: '海外合规', value: '海外合规' },
      { id: '106', label: '海商海事', value: '海商海事' },
      { id: '107', label: '跨境电商', value: '跨境电商' },
      { id: '108', label: '知识产权', value: '知识产权' },
      { id: '108', label: '反倾销反补贴', value: '反倾销反补贴' },
      { id: '108', label: '国际仲裁', value: '国际仲裁' },
      { id: '108', label: '国际商事调解', value: '国际商事调解' },
      { id: '108', label: '跨境司法救济', value: '跨境司法救济' },
      { id: '108', label: '涉外法律援助', value: '涉外法律援助' },
      { id: '108', label: '新兴产业', value: '新兴产业' }
    ]
  },
  {
    id: '2',
    label: '个人业务类',
    value: '个人业务类',
    children: [
      { id: '201', label: '出国探亲', value: '出国探亲' },
      { id: '202', label: '访友', value: '访友' },
      { id: '203', label: '留学', value: '留学' },
      { id: '204', label: '就业', value: '就业' },
      { id: '205', label: '劳务', value: '劳务' },
      { id: '206', label: '旅游', value: '旅游' },
      { id: '207', label: '商务', value: '商务' },
      { id: '208', label: '定居', value: '定居' },
      { id: '209', label: '交通事故', value: '交通事故' },
      { id: '210', label: '婚姻', value: '婚姻' },
      { id: '210', label: '遗产信托', value: '遗产信托' },
      { id: '211', label: '跨境民商事', value: '跨境民商事' }
    ]
  }
]
export default { countries, languages, professions, segments }
